import React from 'react';
// import './FormComponent.scss';

import {
    IconButton,
    TextField,
    InputAdornment,
    Card,
} from '@mui/material';

import CustomFormTitle from './CustomFormTitle';
import styled from 'styled-components';
import { FormTextFieldInterface } from '../../Models/Common/FormFieldComponentInterfaces';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import CustomTooltip from './CustomTooltip';

const StyledFormTextfield = styled.div<{ $isdarkmode: boolean; $isMultiline: boolean }>`
    width: 100%;
    
    textarea {
        overflow-y: scroll !important;
    }

    .MuiInputBase-root {
        max-height: ${props => props.$isMultiline ? 'auto' : '37px !important'};
        font-size: 0.9rem !important;
        color: ${props => props.theme.primaryText};

        &::placeholder {
            color: var(--fieldFocusedBorderPrimaryColor);
            opacity: 0.8;
        }
            
        .Mui-disabled {
            // background-color: ${(props) => (props.theme.disabled)};
            background-color: ${(props) => (props.$isdarkmode ? '#242728' : '#e9ebec')};
        }
    }

    .MuiInputBase-root.Mui-disabled {
        background: ${(props) => (props.$isdarkmode ? '#242728' : '#e9ebec')};
        input {
            -webkit-text-fill-color: var(--disabledFieldFontColor) !important;
        }
    }

    .MuiTextField-root {
        margin-top: 0px !important;
        background: ${props => props.theme.fieldBackgroundColor};
    }

    .MuiOutlinedInput-root {
        padding: 0px !important;

        .iconBtnStyle {
            width: 33px;
            height: 33px;
            margin: 0px;
        }
    }

    .MuiInputBase-input {
        padding:  7px 8px !important;
    }

    .MuiFormHelperText-root {
        margin-left: 0px !important;
    }

    .MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth.MuiTextField-root {
        margin: 0px !important;
    }

    .fieldNoteContainer {
        font-size: .675em;
        font-weight: 400;
        color: #878a99 !important;
    }
`;

const TextfieldContainer = styled.div <{ $darkMode?: boolean; $position?: string; }>`
    display: flex;
    justify-content: space-between;

    .MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth.MuiTextField-root {
        .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-sizeSmall {
            border-radius: ${props => props.$position == 'start' ? '0px 4px 4px 0px' : (props.$position == 'end' ? '4px 0px 0px 4px' : '4px')}!important;
        }
    }
`;

const SideContainer = styled(Card) <{ $darkMode?: boolean; $position?: string; }>`
    // background: #e9ebec !important;
    border: 1px solid;
    border-left: ${props => props.$position == 'start' ? '1px solid' : 'none'};
    border-right: ${props => props.$position == 'start' ? 'none' : '1px solid'};
    border-radius: ${props => props.$position == 'start' ? '4px 0px 0px 4px' : '0px 4px 4px 0px'}!important;
    box-shadow: none !important;
    height: 35px;
    font-size: .775rem !important;
    font-weight: 400 !important;
    align-content: center;
    padding: 0px 20px 0px 15px;
    color: ${props => props.theme.primaryText};
`;

const FormTextField = (fieldProps: FormTextFieldInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();

    //Variable
    let searchTimer: any = null;
    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;

    //Event Handlers
    const onKeyUpUpdateState = (e: any) => {
        if(fieldProps.handleOnChange) {
            fieldProps.handleOnChange(e.target.value);
        }
        // clearTimeout(searchTimer);

        // searchTimer = setTimeout(() => {
        //     let parameters = null;

        //     if (fieldProps.isEnableSubmitEnter && e.keyCode === 13 && !e.shiftKey) {
        //         e.preventDefault();
        //         fieldProps.onKeyupTrigger(); //submit form
        //     } else {
        //         parameters = e.target.value;

        //         if (fieldProps.onKeyupTrigger && !fieldProps.isEnableSubmitEnter) {
        //             fieldProps.onKeyupTrigger(parameters);
        //         } else {
        //             fieldProps.handleOnChange(parameters)
        //         }
        //     }
        // }, 100);
    }

    //Rendering UIs
    const renderTextFieldUI = () => {
        let inputPropsValue: any = { autoComplete: 'new-password', inputProps: { maxLength: fieldProps?.maxLength ?? 5000, } };

        if (fieldProps.icon) {
            let btnIcon = (fieldProps.icon ? <InputAdornment position={fieldProps.iconPosition} className={(fieldProps.onClickIconTrigger ? "" : "notBtnIcon")}>
                {fieldProps.onClickIconTrigger ?
                    <IconButton
                        onClick={fieldProps.onClickIconTrigger}
                        disabled={fieldProps.disabled}
                        className="iconBtnStyle" >
                        {fieldProps.icon}
                    </IconButton> : fieldProps.icon
                }
            </InputAdornment> : null),
                field = (fieldProps.iconPosition === 'end' ?
                    'endAdornment' : (fieldProps.iconPosition === 'start' ?
                        'startAdornment' : null
                    )
                );


            if (field && btnIcon) {
                inputPropsValue[field] = btnIcon;
            }
        }

        const isMultiple = fieldProps.multiline
        

        return <TextField
            key={fieldProps.name}
            variant="outlined"
            margin="normal"
            required={fieldProps.required}
            type={fieldProps.type}
            fullWidth
            size='small'
            error={errorMsg != null && errorMsg != ""}
            helperText={errorMsg ?? ''}
            multiline={isMultiple}
            rows={fieldProps.rows ?? (isMultiple ? 4 : 1)}
            id={fieldProps.disabled ? "outlined-disabled" : "outlined-basic"}
            name={fieldProps.name}
            // defaultValue={(fieldProps.fieldValue != null && fieldProps.fieldValue != "" ? fieldProps.fieldValue : "")}
            value={(fieldProps.fieldValue != null && fieldProps.fieldValue != "" ? fieldProps.fieldValue : "")}
            autoFocus={fieldProps.isAutofocus}
            disabled={fieldProps.disabled}
            // placeholder={(fieldProps.placeholder ? fieldProps.placeholder + (fieldProps.required ? " *" : "") : '')
            // }
            placeholder={(fieldProps?.placeholder ?? '')}
            onChange={(e: any) => {
                onKeyUpUpdateState(e);
            }}
            onPaste={fieldProps.onPaste}
            slotProps={inputPropsValue}
            InputProps={inputPropsValue}
            sx={{
                '& .MuiInputBase-input': {
                    textAlign: (fieldProps?.isRightAlign ? 'right' : 'left'),

                    '&::placeholder': {
                        textAlign: (fieldProps?.isRightAlign ? 'right' : 'left'),
                    },
                },
            }} />
    }

    return <StyledFormTextfield $isdarkmode={isDarkMode} $isMultiline={fieldProps.multiline ?? false} className={"formTextFieldContainer " + (fieldProps?.fieldClassName != null && fieldProps?.fieldClassName != "" ? fieldProps.fieldClassName : "")}>
        {/* ---------TITLE---------- */}
        {!fieldProps.hideLabel && <CustomFormTitle title={fieldProps.title}
            required={fieldProps.required}
            hideLabel={fieldProps.hideLabel}
            exclamationHoverItemDisplayText={fieldProps.exclamationHoverItemDisplayText} />}

        {/* ---------SIDE CONTENT---------- */}
        <div className="labelSideContentContainer">{fieldProps.labelSideContent}</div>

        {/* ---------TEXTFIELD---------- */}
        <TextfieldContainer $position={fieldProps?.sideContentPosition}>
            {(fieldProps?.sideContent && fieldProps?.sideContentPosition == "start") && <SideContainer sx={{backgroundColor: 'disabled', borderColor: (errorMsg != null && errorMsg != "" ? 'customBorder.errorBorder' : 'customBorder.main'), color: 'primaryText'}} $position={fieldProps.sideContentPosition}>{fieldProps.sideContent}</SideContainer>}
            {renderTextFieldUI()}
            {(fieldProps?.sideContent && fieldProps?.sideContentPosition == "end") && <SideContainer sx={{backgroundColor: 'disabled', borderColor: (errorMsg != null && errorMsg != "" ? 'customBorder.errorBorder' : 'customBorder.main'), color: 'primaryText'}} $position={fieldProps.sideContentPosition}>{fieldProps.sideContent}</SideContainer>}
        </TextfieldContainer>
        {/* ---------NOTE---------- */}
        {fieldProps.note != null && fieldProps.note != "" && <span className="fieldNoteContainer">{fieldProps.note}</span>}

        {/* ---------SUBLABEL---------- */}
        {(fieldProps.showSubLabel ? <span className="subLabelContainer">{fieldProps.subLabel}</span> : "")}
    </StyledFormTextfield>
}

export default FormTextField;